import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da058626")

_pushScopeId("data-v-da058626")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "form",
    model: _ctx.formData,
    "label-width": "80px"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form_item, {
        prop: "name",
        rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
        label: "名称"
      }, {
        default: _withId(() => [
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.currentWords.name), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "categoryIds",
        rules: [{ required: true,message: '请输入分类',trigger: 'blur' }],
        label: "分类"
      }, {
        default: _withId(() => [
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_cascader, {
                key: 0,
                filterable: "",
                modelValue: _ctx.formData.categoryIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.categoryIds = $event)),
                options: _ctx.templateCategoryStore.wordsCategories,
                props: {value: 'id', label: 'name', checkStrictly: true}
              }, null, 8, ["modelValue", "options"]))
            : (_openBlock(), _createBlock(_component_el_breadcrumb, {
                key: 1,
                style: {"line-height":"unset"},
                separator: "/"
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryPath, (item) => {
                    return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: item }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "tags",
        label: "标签"
      }, {
        default: _withId(() => [
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_tag_input, {
                key: 0,
                allowAddNewTag: false,
                modelValue: _ctx.formData.tags,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.tags = $event))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentWords.tags, (tag) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: tag,
                    "disable-transitions": false
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(tag.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_el_input, {
        class: "w-0",
        type: "hidden",
        modelValue: _ctx.formData.templateId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.templateId = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "w-0",
        type: "hidden",
        modelValue: _ctx.formData.wordsUrl,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.wordsUrl = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "w-0",
        type: "hidden",
        modelValue: _ctx.formData.duration,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.duration = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "w-0",
        type: "hidden",
        modelValue: _ctx.formData.fileSize,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.fileSize = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_form_item, { class: "flex-center" }, {
        default: _withId(() => [
          (_ctx.editMode==='MODIFY' && !_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "margin-right-10",
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editing=true))
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "margin-right-10",
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                onClick: _ctx.cancel
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
})